import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage2 from '../Routes/HomePage2';
import SubscriptionPage from '../Routes/SubscriptionPage';
import RedirectPage from '../Routes/RedirectPage';
import LoginPage from '../Routes/LoginPage';

const Routing = () => {
   const router = createBrowserRouter([
    {
      path: "/home",
      element: <HomePage2 />,
    },
    {
      path:"/",
      element:<SubscriptionPage />
    },
    {
      path:"/redirect",
      element:<RedirectPage />
    },
    {
      path:"/login",
      element:<LoginPage />
    }
  ]);
  return (
    <RouterProvider router={router} />
  )
}

export default Routing